import React, { useEffect, useState } from "react";
import { profileUser } from "../api/service";
import Navbar from "../components/Navbar";
import { useParams } from "react-router-dom";
import { getPost } from "../api/service";
import { useNavigate } from "react-router";
import { FaThumbsUp, FaThumbsDown, FaCity, FaFlag } from "react-icons/fa";
import { MdCategory, MdTimer } from "react-icons/md";
import Footer from "../components/Footer";
import Chart from "chart.js/auto";
import { Doughnut } from "react-chartjs-2";
import profile from "../images/aayush.png";
import jslogo from "../images/Logo.png";

const SpecificProfile = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [category, setCategory] = useState("");
  const [likes, setLikes] = useState(0);
  const [dislikes, setDislikes] = useState(0);
  const [created, setCreated] = useState("");
  const [updated, setUpdated] = useState("");

  const formatDateTime = (dateTimeString) => {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    return new Date(dateTimeString).toLocaleDateString(undefined, options);
  };

  let token = localStorage.getItem("token");
  const navigate = useNavigate();
  const { id } = useParams();
  //console.log(id);
  const profileInit = () => {
    profileUser(token).then((req, res) => {
      console.log(req.data);
      if (req.data.status !== "failed") {
        console.log(req.data);
      } else {
        navigate("/");
      }
    });
  };

  useEffect(() => {
    profileInit();
  }, []);

  const postInit = (id) => {
    getPost(id).then((req, res) => {
      console.log(req.data.likes);
      setTitle(req.data.title);
      setDescription(req.data.description);
      setImage(req.data.image);
      setCity(req.data.city);
      setState(req.data.state);
      setCountry(req.data.country);
      setCategory(req.data.category);
      setLikes(req.data.likes.length);
      setDislikes(req.data.dislikes.length);
      setUpdated(req.data.updatedAt);
    });
  };

  useEffect(() => {
    postInit(id);
  }, []);

  const labels = ["Likes", "Dislikes"];
  const data = {
    labels: labels,
    datasets: [
      {
        label: "Count",
        backgroundColor: ["#43b258", "#d63939"],
        hoverOffset: 5,
        data: [likes, dislikes],
      },
    ],
  };

  return (
    <>
      <Navbar />
      <div className="dark:bg-[#010409] bg-white ">
        {/* <div className="dark:bg-[#161B22] bg-white pt-32 lg:w-[80%] sm:w-2/3 flex flex-col m-auto items-center">
          <img
            src={`${image}`}
            alt=""
            className="self-center inline object-contain w-full h-40 rounded-t-lg  md:rounded-none md:rounded-l-lg"
          />

          <h1 className="mb-3 text-2xl font-bold text-center uppercase dark:text-white text-slate-800">
            Title : <span className="text-[#0A58C4]">{title}</span>
          </h1>
          <div className=" font-medium  dark:bg-[#0D1117] bg-[#a4b6cf] text-gray-700  dark:text-[#c9d1d9] w-full rounded-lg shadow-xl shadow-gray-500 dark:shadow-gray-300">
            <h1 className="p-4 place-content-center">
              Description : {description} <br />
            </h1>
            <div className="lg:w-[40%] lg:ml-[30%] items-center">
              <Doughnut data={data} />
            </div>
            <br />
            <button className=" shadow-none dark:text-[#d7dfe7] text-gray-700 bg-transparent font-bold py-2 px-4 mr-4  hover:border-[#2e49a0] border-2 rounded-xl w-1/2 h-14 my-4 ml-4">
              <div style={{ display: "flex", justifyContent: "center" }}>
                <FaCity size={25} /> &nbsp; City : {city}
              </div>
            </button>
            <button className=" shadow-none dark:text-[#d7dfe7] text-gray-600 bg-transparent font-bold py-2 px-4 mr-4  hover:border-[#2e49a0] border-2 rounded-xl w-1/2 h-14 my-4">
              <div style={{ display: "flex", justifyContent: "center" }}>
                <FaCity size={25} /> &nbsp; State : {state}
              </div>
            </button>
            <br />
            <button className=" shadow-none dark:text-[#d7dfe7] text-gray-600 bg-transparent font-bold py-2 px-4 mr-4 ml-4 hover:border-[#2e49a0] border-2 rounded-xl w-1/2 h-14 my-4">
              <div style={{ display: "flex", justifyContent: "center" }}>
                <FaFlag size={25} /> &nbsp; Country_code : {country}
              </div>
            </button>
            <button className=" shadow-none dark:text-[#d7dfe7] text-gray-600 bg-transparent font-bold py-2 px-4 mr-4  hover:border-[#2e49a0] border-2 rounded-xl w-1/2 h-14 my-4">
              <div style={{ display: "flex", justifyContent: "center" }}>
                <MdCategory size={25} /> &nbsp; Category : {category}
              </div>
            </button>
            <br />
            <button className=" shadow-none dark:text-[#d7dfe7] text-gray-600 bg-transparent font-bold py-2 px-4  hover:border-[#2e49a0] border-2 rounded-xl w-1/2 h-24 my-4">
              <div
                className="text-sm"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <MdTimer size={25} /> &nbsp; Created on :{" "}
                {formatDateTime(created)} <br />
                &nbsp; Last Updated on : {formatDateTime(updated)}
              </div>
            </button>
          </div>

          <ol class="relative border-s my-10 p-6 border-gray-200 dark:border-gray-700">
            <li class="mb-10 ms-6">
              <span class="absolute flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full -start-3 ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900">
                <img
                  class="rounded-full shadow-lg"
                  src={profile}
                  alt="Bonnie image"
                />
                
              </span>
              <div class="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:flex dark:bg-gray-700 dark:border-gray-600">
                <time class="mb-1 text-xs font-normal text-gray-400 sm:order-last sm:mb-0">
                  1 day ago
                </time>
                <div class="text-sm font-normal text-gray-500 lex dark:text-gray-300">
                  Username* posted{" "}
                  <a
                    href="#"
                    class="font-semibold text-blue-600 dark:text-blue-500 hover:underline"
                  >
                    Category*
                  </a>{" "}
                  task/news
                </div>
              </div>
            </li>
            <li class="mb-10 ms-6">
              <span class="absolute flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full -start-3 ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900">
                <img
                  class="rounded-full shadow-lg"
                  src={jslogo}
                  alt="Thomas Lean image"
                />
                
              </span>
              <div class="p-4 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-700 dark:border-gray-600">
                <div class="items-center justify-between mb-3 sm:flex">
                  <time class="mb-1 text-xs font-normal text-gray-400 sm:order-last sm:mb-0">
                    2 hours ago
                  </time>
                  <div class="text-sm font-normal text-gray-500 lex dark:text-gray-300">
                    Jal Suraksha (Bot) commented on{" "}
                    <a
                      href="#"
                      class="font-semibold text-gray-900 dark:text-white hover:underline"
                    >
                      Username's post
                    </a>
                  </div>
                </div>
                <div class="p-3 text-xs italic font-normal text-gray-500 border border-gray-200 rounded-lg bg-gray-50 dark:bg-gray-600 dark:border-gray-500 dark:text-gray-300">
                  Hi ya'll! I wanted to share a webinar zeroheight is having
                  regarding how to best measure your design system! This is the
                  second session of our new webinar series on #DesignSystems
                  discussions where we'll be speaking about Measurement.
                </div>
              </div>
            </li>
            <li class="ms-6">
              <span class="absolute flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full -start-3 ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900">
                <img
                  class="rounded-full shadow-lg"
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQj-Kmd5ocqdlJ8zquXE9KTBCAzbVQlylNajw&usqp=CAU"
                  alt="Jese Leos image"
                />
              </span>
              <div class="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:flex dark:bg-gray-700 dark:border-gray-600">
                <time class="mb-1 text-xs font-normal text-gray-400 sm:order-last sm:mb-0">
                  just now
                </time>
                <div class="text-sm font-normal text-gray-500 dark:text-gray-300">
                  News has been tagged as {" "}
                  <a
                    href="#"
                    class=" text-blue-600 dark:text-blue-500 hover:underline"
                  >
                    <span class="font-semiboldbg-gray-100 text-blue-600 dark:text-blue-500 text-xs font-normal me-2 px-2.5 py-0.5 rounded dark:bg-gray-600">
                    Initiated
                  </span>
                  </a>{" "}
                  and sent to the{" "}
                  Location-based Authority*
                </div>
              </div>
              
            </li>
          </ol>
        </div> */}
        <div class="max-w-[85rem] mx-auto p-4 sm:p-6 lg:px-8">
          <div class="grid md:grid-cols-2 gap-4 md:gap-8 xl:gap-20 md:items-center">
            <div>
              <h1 class="block text-3xl font-bold text-gray-800 sm:text-4xl lg:text-6xl lg:leading-tight dark:text-white">
                {title}
              </h1>
              <p class="mt-3 text-lg text-gray-800 dark:text-gray-400">
                {description}
              </p>

              <div class="mt-7 grid gap-3 w-full sm:inline-flex">
                <div className="lg:w-[40%] lg:ml-[30%] items-center">
                  <Doughnut data={data} />
                </div>
                {/* <a class="py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" href="#">
          
          <svg class="flex-shrink-0 w-4 h-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>
        </a>
        <a class="py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-white dark:hover:bg-gray-800 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" href="#">
          Contact sales team
        </a> */}
              </div>
            </div>

            <div class="relative ms-4">
              <img
                class="w-full rounded-md mt-5"
                src={`${image}`}
                alt="Image Description"
              />
              <div class="absolute inset-0 -z-[1] bg-gradient-to-tr from-gray-200 via-white/0 to-white/0 w-full h-full rounded-md mt-4 -mb-4 me-4 -ms-4 lg:mt-6 lg:-mb-6 lg:me-6 lg:-ms-6 dark:from-slate-800 dark:via-slate-900/0 dark:to-slate-900/0"></div>
              <div class="absolute bottom-0 left-0">
                <span class="inline-flex items-center px-2 py-1 mr-2 bg-gray-200 hover:bg-gray-300 rounded-t-xl text-xs font-semibold text-gray-600">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 32 32"
                  >
                    <circle cx="16" cy="16" r="8" fill="#6c6a6a" />
                  </svg>
                  <span class="ml-1">{category}</span>
                </span>
              </div>
            </div>
          </div>
          <ol class="relative border-s my-10 p-6 border-gray-200 dark:border-gray-700">
            <li class="mb-10 ms-6">
              <span class="absolute flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full -start-3 ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900">
                <img
                  class="rounded-full shadow-lg"
                  src={profile}
                  alt="Bonnie image"
                />
              </span>
              <div class="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:flex dark:bg-gray-700 dark:border-gray-600">
                <time class="mb-1 text-xs font-normal text-gray-400 sm:order-last sm:mb-0">
                  1 day ago
                </time>
                <div class="text-sm font-normal text-gray-500 lex dark:text-gray-300">
                  Username* posted{" "}
                  <a
                    href="#"
                    class="font-semibold text-blue-600 dark:text-blue-500 hover:underline"
                  >
                    Category*
                  </a>{" "}
                  task/news
                </div>
              </div>
            </li>
            <li class="mb-10 ms-6">
              <span class="absolute flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full -start-3 ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900">
                <img
                  class="rounded-full shadow-lg"
                  src={jslogo}
                  alt="Thomas Lean image"
                />
              </span>
              <div class="p-4 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-700 dark:border-gray-600">
                <div class="items-center justify-between mb-3 sm:flex">
                  <time class="mb-1 text-xs font-normal text-gray-400 sm:order-last sm:mb-0">
                    2 hours ago
                  </time>
                  <div class="text-sm font-normal text-gray-500 lex dark:text-gray-300">
                    Jal Suraksha (Bot) commented on{" "}
                    <a
                      href="#"
                      class="font-semibold text-gray-900 dark:text-white hover:underline"
                    >
                      Username's post
                    </a>
                  </div>
                </div>
                <div class="p-3 text-xs italic font-normal text-gray-500 border border-gray-200 rounded-lg bg-gray-50 dark:bg-gray-600 dark:border-gray-500 dark:text-gray-300">
                  Welcome to JAL SURAकSHA! 🌊 Join us in revolutionizing
                  disaster management through innovative solutions. Follow for
                  updates on our mission to harness social media data for
                  water-related challenges. Let's make a difference together!
                  #JalSuraksha #HumaaraDeshHumaariZimmedaari
                </div>
              </div>
            </li>
            <li class="ms-6">
              <span class="absolute flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full -start-3 ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900">
                <img
                  class="rounded-full shadow-lg"
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQj-Kmd5ocqdlJ8zquXE9KTBCAzbVQlylNajw&usqp=CAU"
                  alt="Jese Leos image"
                />
              </span>
              <div class="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:flex dark:bg-gray-700 dark:border-gray-600">
                <time class="mb-1 text-xs font-normal text-gray-400 sm:order-last sm:mb-0">
                  just now
                </time>
                <div class="text-sm font-normal text-gray-500 dark:text-gray-300">
                  News has been tagged as{" "}
                  <a
                    href="#"
                    class=" text-blue-600 dark:text-blue-500 hover:underline"
                  >
                    <span class="font-semiboldbg-gray-100 text-blue-600 dark:text-blue-500 text-xs font-normal me-2 px-2.5 py-0.5 rounded dark:bg-gray-600">
                      Initiated
                    </span>
                  </a>{" "}
                  and sent to the Location-based Authority*
                </div>
              </div>
            </li>
          </ol>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SpecificProfile;
